export const questions: Array<[string, string]> = [
  [
    'Per chi è questa collezione?',
    'Per i docenti della scuola secondaria che devono insegnare ambiente, ecosistemi, risorse, inquinamento, rifiuti, clima e sostenibilità in modo chiaro e pronto all’uso.',
  ],
  ['In che formato ricevo il materiale?', 'In PDF scaricabili, da consultare su computer, tablet o da stampare.'],
  ['Quando ricevo l’accesso?', 'Subito dopo il pagamento ricevi via email il link di accesso.'],
  [
    'Serve una preparazione specifica in gestione ambientale?',
    'No, i contenuti partono dalle basi e arrivano ai temi più avanzati in modo progressivo.',
  ],
  [
    'Posso usarlo con i miei studenti?',
    'Sì, è pensato per l’uso in classe: attività, casi pratici, progetti e verifiche pronti.',
  ],
  ['C’è una garanzia?', 'Sì, hai 7 giorni di garanzia di soddisfazione.'],
];
